import {Button, Menu, Typography} from "@mui/material";
import {RichTreeView} from "@mui/x-tree-view";
import {useEffect, useMemo, useState} from "react";
import {normalizeLocationTreeItems} from "../../utils/filters";

export const LocationPicker = ({locations, locationSetter, filters}) => {
    const [anchorElement, setAnchorElement] = useState(null);
    const [locationIdToNameMap, setLocationIdToNameMap] = useState({'ALL': 'ALL'});
    const [selectedIds, setSelectedIds] = useState(['ALL']);
    const [selectedName, setSelectedName] = useState('ALL');

    const treeItems = useMemo(
        () => [{id: 'ALL', label: 'ALL'}, ...normalizeLocationTreeItems(locations)],
        [locations]
    );

    const extractLocationNamesMap = (locs, resultMap) => {
        for (const l of locs) {
            resultMap[l.id] = l.label || l.name;
            if (l.children) {
                extractLocationNamesMap(l.children, resultMap);
            }
        }
        return resultMap;
    };

    useEffect(() => {
        setLocationIdToNameMap(extractLocationNamesMap(treeItems, {'ALL': 'ALL'}));
    }, [treeItems]);

    useEffect(() => {
        if (!filters.locationId && !filters.salesPersonId) {
            setSelectedIds(['ALL']);
            setSelectedName('ALL');
        }
    }, [filters]);

    const handleClick = (event) => {
        setAnchorElement(event.currentTarget);
    };

    const handleSelection = (event, id) => {
        setAnchorElement(null);
        if (id !== selectedIds) {
            setSelectedIds(id);
            const selectedId = Array.isArray(id) ? id[0] : id;
            setSelectedName(locationIdToNameMap[selectedId]);
            locationSetter(selectedId);
        }
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    return (
        <div>
            <Typography variant="h7" display="inline">Sales Territory:</Typography>
            <Button onClick={handleClick}>{selectedName}</Button>
            <Menu id="PickerMenu" anchorEl={anchorElement} keepMounted open={Boolean(anchorElement)}
                  onClose={handleClose}>
                <RichTreeView items={treeItems} selectedItems={selectedIds}
                              onSelectedItemsChange={handleSelection} checkboxSelection/>
            </Menu>
        </div>
    );
};
